import { fetchOrderSchema, fetchCustomers } from '../api/orders';

const state = {
    schema: {},
    customers: [],
};

const getters = {};

const mutations = {
    SET_ORDER_SCHEMA(state, schema) {
        state.schema = Object.freeze(schema);
    },
    SET_CUSTOMERS(state, customers) {
        state.customers = Object.freeze(customers);
    },
};

const actions = {
    async fetchOrderSchema({ commit }) {
        commit('SET_ORDER_SCHEMA', await fetchOrderSchema());
    },
    async fetchCustomers({ commit }) {
        commit('SET_CUSTOMERS', await fetchCustomers());
    },
    async fetchData({ dispatch }) {
        await Promise.all([dispatch('fetchOrderSchema'), dispatch('fetchCustomers')]);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
